(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('RptCategory', RptCategory);

    RptCategory.$inject = ['$resource'];

    function RptCategory ($resource) {
        var resourceUrl =  'api/rpt-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
